<template>
    <v-dialog v-model="dialogEditar" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
        <v-card class="mt-5">
            <v-toolbar flat dark color="primary">
                <v-btn icon dark @click="dialogCerrar = true">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="mt-5 pt-2">
                    <v-text-field dense label="Nombre" v-model="nombreGrupo" ></v-text-field></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="guardarEdicion()">Guardar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="5">
                        <v-card :loading="loading">
                            <v-card-title class="pb-0">
                                Clientes para añadir:
                            </v-card-title>
                            <v-text-field class="mr-5 ml-5 pt-0" v-model="searchCliente2" append-icon="mdi-file-search-outline" label="Buscar" single-line hide-details></v-text-field>
                            <v-data-table
                                :headers="headersEditar" 
                                :items="clientesAnadir" 
                                :search="searchCliente2" 
                                v-model="clientesSelecAnadir"
                                item-key="code"
                                show-select
                                class="elevation-1" 
                                hide-default-footer 
                                disable-pagination/>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" align-self="start" :class="[$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '' : 'sticky']" :style="[$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '' : {'padding-top': '350px'}]">
                        <div class="text-center">
                            <v-btn outlined :disabled="clientesSelecAnadir.length === 0" @click="anadirQuitarCliente(clientesSelecAnadir, clientesGrupo, clientesAnadir, true)">
                                <v-icon v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs">
                                   mdi-chevron-down  
                                </v-icon>
                                <v-icon v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </div>
                        <br>
                        <div class="text-center">
                            <v-btn outlined :disabled="clientesSelecQuitar.length === 0" @click="anadirQuitarCliente(clientesSelecQuitar, clientesAnadir, clientesGrupo, false)">
                                <v-icon v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs">
                                    mdi-chevron-up <!-- si la pantalla es grande mostramos el simbolo < -->
                                </v-icon>
                                <v-icon v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
                                    mdi-chevron-left <!-- si la pantalla es pequeña mostramos el simbolo ^ -->
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="5">
                        <v-card :loading="loading">
                            <v-card-title class="pb-0">
                                Clientes del grupo:
                            </v-card-title>
                            <v-text-field class="mr-5 ml-5 pt-0" v-model="searchCliente1" append-icon="mdi-file-search-outline" label="Buscar" single-line hide-details></v-text-field>                      
                            <v-data-table 
                                :headers="headersEditar" 
                                :items="clientesGrupo" 
                                :search="searchCliente1" 
                                v-model="clientesSelecQuitar"
                                item-key="code"
                                show-select
                                class="elevation-1"
                                hide-default-footer
                                disable-pagination
                                no-data-text="Este grupo no contiene ningún cliente"/>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row justify="center">
            <v-dialog v-model="dialogCerrar" persistent max-width="380">
                <v-card>
                    <v-card-title class="headline">¡Atención!</v-card-title>
                    <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="cancelarEdicion()">Salir</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-dialog>    
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import uuidv4 from '../../../mixins/uuidv4';
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'FullDialog',
    props: ['clientesTodos', 'clientesGrupo', 'clientesAnadir', 'comerciales'],
    mixins: [uuidv4],
    data: () => ({
        loading: false,
        headersEditar: [
            {
                text: 'Cliente',
                filterable: true,
                value: 'name'
            },
        ],
        searchCliente1: '',
        searchCliente2: '',
        clientesSelecAnadir: [],
        clientesSelecQuitar: [],
        dialogCerrar: false
    }),
    created(){
        if (!this.tecnicos.length) {
            this.$store.dispatch("usuarios/getUsuarios");
        }
        this.nombreGrupo = this.grupo.nombre;
        if(this.grupo.orden_contratos){
            this.grupo.orden_contratos = this.grupo.orden_contratos.join();
        }
    },
    methods: {
        ...mapActions('misGrupos', ['setDialogEditar']),
        ...mapActions(['setLoading', 'setSnackbar']),
        async anadirQuitarCliente(arraySelec, arrayAñadir, arrayEliminar, añadiendoAlGrupo){ //arraySelec=array con seleccion usuario, arrayAñadir= array en el que se añaden los clientes, arrayEliminar= array en el que se eliminan los clientes
            this.setLoading(true);

            let clientesSinDelegacion = [];
            if(añadiendoAlGrupo){
                try {
                    let peticionDelegaciones = {
                        accionesMasivas: true,
                        clientesGrupo: arraySelec,
                        identificadorCli: 'code'
                    };
                    // let respuesta = await axios.get(`/api/delegacionesClientes?sentenciaPeticion=${sentanciaPeticion}`);
                    let respuesta = await axios.post(`/api/delegacionesClientes`, peticionDelegaciones);
                    let delegaciones = respuesta.data;

                    for (const cliente of arraySelec){
                        let delegacionesCliente = delegaciones.filter(d => d.clienteId === cliente.code);

                        // let idComercialReferencia = null;
                        let comercialReferencia = this.comerciales.filter(item => item.email === cliente.comercialEmail);
                        try{
                            let respuestaResponsable = await axios.get(`/api/tecnicosCliente?cliente_id=${cliente.code}`);
                            let responsable_id = (this.tecnicos.find(tecnico => tecnico.email === respuestaResponsable.data[0].responsableCuenta))?.id;
                            //Verificamos si el cliente tiene delegaciones, responsable técnico y si el comercial está informado y existe en la aplicación de partes
                            if(delegacionesCliente.length > 0 && comercialReferencia.length > 0 && responsable_id !== undefined){
                                this.añadidoDeClientes(cliente, arrayAñadir, arrayEliminar);
                            }else{
                                clientesSinDelegacion.push(cliente.name);
                            }
                        }catch(error){ // La api cuando hace una petición a Dynamics con un cliente que no existe en dynamics resuelve con un 404 (not found) que hay que capturar
                            clientesSinDelegacion.push(cliente.name);
                        }
                    }
                    
                } catch (error) {
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido añadir los clientes'
                    });
                }
            }else{
                arraySelec.forEach(cliente => {
                    this.añadidoDeClientes(cliente, arrayAñadir, arrayEliminar);
                });
            }

            if(clientesSinDelegacion.length == 1){
                this.setSnackbar({
                    tipo: 'warning',
                    mensaje: 'El cliente ' + clientesSinDelegacion[0] + ' no se ha podido añadir al grupo porque no tiene delegación, responsable de cuenta y/o comercial informado en BC/Dynamics.'
                });
            }else if(clientesSinDelegacion.length > 1){
                let nombresClientes = "";
                clientesSinDelegacion.forEach(cliente => {
                    if(cliente == clientesSinDelegacion[0]){
                        nombresClientes = cliente;
                    }else if (cliente == clientesSinDelegacion[clientesSinDelegacion.length -1]){
                        nombresClientes = nombresClientes + " y " + cliente;
                    }else{
                        nombresClientes = nombresClientes + ", " + cliente;
                    }
                });
                this.setSnackbar({
                    tipo: 'warning',
                    mensaje: 'Los clientes ' + nombresClientes + ' no se han podido añadir al grupo porque no tiene delegación, responsable de cuenta y/o comercial informado en BC/Dynamics.'
                });
            }
            this.clientesSelecAnadir = [];
            this.clientesSelecQuitar = [];
            this.setLoading(false);
        },
        añadidoDeClientes(cliente, arrayAñadir, arrayEliminar){
            arrayAñadir.push(cliente); //añado los clientes en el array correspondiente
            arrayAñadir = arrayAñadir.sort(function (a, b){ //ordenamos el array por id
                return (Number(b.code.substr(1)) - Number(a.code.substr(1)))
            }).reverse();
            for (var i = arrayEliminar.length; i--;) { 
                if (arrayEliminar[i].code === cliente.code) {
                    arrayEliminar.splice(i, 1); //elimino los clientes del otro array
                }
            }
        },
        async guardarEdicion(){
            try {
                if(this.nombreGrupo !== ''){
                    this.setLoading(true);
                    this.grupo.nombre = this.nombreGrupo;
                    this.grupo.clientes = this.clientesGrupo;
                    await axios.patch('/api/gruposaccionesmasivas', this.grupo); //GUARDO EL NOMBRE Y LOS CLIENTES

                    this.cancelarEdicion();
                    
                    this.setSnackbar({
                        tipo: 'success',
                        mensaje: 'Datos guardados correctamente'
                    });
                    this.setLoading(false);
                }else{
                    this.setSnackbar({
                        tipo: 'warning',
                        mensaje: 'Es necessario que el grupo conste de nombre'
                    });
                }
                
            } catch (error) {
                this.cancelarEdicion();
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido editar los datos'
                });
            }
        },
        cancelarEdicion(){
            if(this.grupo.orden_contratos){
                this.grupo.orden_contratos = this.grupo.orden_contratos.split(',').map(Number);
            }
            this.setDialogEditar(false);
            this.nombreGrupo = '';
        }
    },
    computed: {
        ...mapState('misGrupos', ['grupo', 'dialogEditar']),
        ...mapGetters({
            tecnicos: "usuarios/tecnicos"
        }),
    }
}
</script>
<style>
    .sticky {
        position: sticky;
        top: 0;
        z-index: 1;
    }
</style>